module.exports = __webpack_public_path__ + "main/images/shared/fuel-your-mind@3x.4a5bd6b2f852145cabfc239c4e099504.png";